import React from 'react';
import { InView } from 'react-intersection-observer';

import SignInOption from '@components/Form/EmailForm/SignInOption';
import useEventTracking from '@hooks/useEventTracking';
import useWindowSize from '@hooks/useWindowSize';
import { Theme } from '@interfaces/global';
import { ImpressionElement, TrackingLocation, impression } from '@tracking';
import { WIDTH_SM } from '@utils/constants';

import { PaywallProps } from '..';
import DownloadApp from './DownloadApp';
import PaywallForm from './Form';

const PaywallFull = (paywallProps: PaywallProps): JSX.Element => {
  const { Track, trackEvent } = useEventTracking({ location: TrackingLocation.Paywall });
  const { width: windowWidth } = useWindowSize();
  return (
    <aside data-testid="paywall">
      <Track>
        <InView
          triggerOnce={true}
          onChange={(inView) => {
            inView && trackEvent(impression({ impressionElement: ImpressionElement.PaywallFull }));
          }}
        >
          <SignInOption
            className="mb-16 pt-8 text-center font-suisse-screen text-disclosure-sm sm:pt-24 md:mb-24"
            theme={
              windowWidth < WIDTH_SM && !paywallProps.isTwoOptPaywall ? Theme.Light : Theme.Dark
            }
          />
          <PaywallForm
            {...paywallProps}
            theme={
              windowWidth < WIDTH_SM && !paywallProps.isTwoOptPaywall ? Theme.Light : Theme.Dark
            }
          />
          <DownloadApp contentId={paywallProps.articleId ?? paywallProps.briefingGuid} />
        </InView>
      </Track>
    </aside>
  );
};

export default PaywallFull;
